import React from 'react';
import { useParams } from 'react-router-dom';

import styled from 'styled-components';

import { Loader } from 'components/Loader';
import { MicrostoreColumnTemplateDetailsForm } from './MicrostoreColumnTemplateDetailsForm';
import { useGetMicrostoreColumnTemplateQuery } from 'data/__generated__';

type ParamTypes = {
    microstoreColumnTemplateId: string;
};

export const MicrostoreColumnTemplateDetails = () => {
    const { microstoreColumnTemplateId = '' } = useParams<ParamTypes>();

    const {
        loading: microstoreColumnTemplateLoading,
        data: microstoreColumnTemplateData,
        error: microstoreColumnTemplateError,
    } = useGetMicrostoreColumnTemplateQuery({
        variables: {
            microstoreColumnTemplateId,
        },
    });

    if (microstoreColumnTemplateLoading) {
        return (
            <Container>
                <Loader />
            </Container>
        );
    }

    if (microstoreColumnTemplateError || !microstoreColumnTemplateData) {
        throw new Error('Une erreur est survenue lors de la récupération du template de colonne');
    }

    const { microstoreColumnTemplateQuery: microstoreColumnTemplate } = microstoreColumnTemplateData;

    return (
        <Container>
            <MicrostoreColumnTemplateDetailsForm microstoreColumnTemplate={microstoreColumnTemplate} />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex: 1;
    background-color: ${({ theme }) => theme.backgroundColor};
    color: ${({ theme }) => theme.textColor};
`;
